import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home-data';

export default function FeatureGrid() {
  const leftArticle = latestArticles[0];
  const rightTop = latestArticles[1];
  const rightBottom = latestArticles[2];

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight">
            热门<span className="text-primary-500">专题</span>
            <br />
            <span className="text-primary-500">独家</span>深扒
          </h2>
          <p className="mt-3 text-sm text-foreground-500">深度调查 · 有图有真相 · 不定期更新</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          <Link
            to={`/article/${leftArticle.id}`}
            className="lg:w-1/2 relative rounded-xl overflow-hidden bg-background-50 cursor-pointer group"
          >
            <div className="aspect-[3/4] lg:aspect-auto lg:h-[480px] overflow-hidden">
              <img
                src={leftArticle.image}
                alt={leftArticle.title}
                title={leftArticle.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full mb-3 whitespace-nowrap">
                {leftArticle.categoryName}
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 leading-snug group-hover:text-primary-300 transition-colors line-clamp-2">
                {leftArticle.title}
              </h3>
              <p className="mt-2 text-sm text-background-50/60 line-clamp-2">{leftArticle.excerpt}</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-background-50/50">
                <span>{leftArticle.date}</span>
                <span>{leftArticle.views.toLocaleString()} 次围观</span>
              </div>
            </div>
          </Link>

          <div className="lg:w-1/2 flex flex-col gap-4 md:gap-5">
            <Link
              to={`/article/${rightTop.id}`}
              className="flex-1 relative rounded-xl overflow-hidden bg-background-50 cursor-pointer group"
            >
              <div className="h-[220px] lg:h-[230px] overflow-hidden">
                <img
                  src={rightTop.image}
                  alt={rightTop.title}
                  title={rightTop.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-2 whitespace-nowrap">
                  {rightTop.categoryName}
                </span>
                <h3 className="font-heading text-base font-bold text-background-50 leading-snug group-hover:text-accent-300 transition-colors line-clamp-2">
                  {rightTop.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-xs text-background-50/50">
                  <span>{rightTop.date}</span>
                  <span>{rightTop.views.toLocaleString()} 围观</span>
                </div>
              </div>
            </Link>

            <Link
              to={`/article/${rightBottom.id}`}
              className="flex-1 relative rounded-xl overflow-hidden bg-background-50 cursor-pointer group"
            >
              <div className="h-[220px] lg:h-[230px] overflow-hidden">
                <img
                  src={rightBottom.image}
                  alt={rightBottom.title}
                  title={rightBottom.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-1 bg-secondary-500 text-background-50 text-xs font-semibold rounded-full mb-2 whitespace-nowrap">
                  {rightBottom.categoryName}
                </span>
                <h3 className="font-heading text-base font-bold text-background-50 leading-snug group-hover:text-secondary-300 transition-colors line-clamp-2">
                  {rightBottom.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-xs text-background-50/50">
                  <span>{rightBottom.date}</span>
                  <span>{rightBottom.views.toLocaleString()} 围观</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}